module.exports = __webpack_public_path__ + "img/shopping_cart_white.b5ab388b.svg";